"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTooltip = exports.withStyledSystem = void 0;
var difference_1 = __importDefault(require("lodash/difference"));
var prop_types_1 = require("prop-types");
var React = __importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
var tooltips_1 = require("./tooltips");
var tooltip = new tooltips_1.Tooltips();
var prop = prop_types_1.oneOfType([prop_types_1.number, prop_types_1.string, prop_types_1.arrayOf(prop_types_1.oneOfType([prop_types_1.number, prop_types_1.string]))]);
var propTypes = {
    width: prop,
    minWidth: prop,
    maxWidth: prop,
    height: prop,
    minHeight: prop,
    maxHeight: prop,
    display: prop,
    fontSize: prop,
    color: prop,
    bg: prop,
    backgroundColor: prop,
    m: prop,
    mt: prop,
    mr: prop,
    mb: prop,
    ml: prop,
    mx: prop,
    my: prop,
    p: prop,
    pt: prop,
    pr: prop,
    pb: prop,
    pl: prop,
    px: prop,
    py: prop,
};
var styledSystemProps = Object.keys(propTypes);
var filterStyledSystemProps = function (passthroughProps) { return function (Base) {
    var omitProps = difference_1.default(styledSystemProps, passthroughProps);
    return React.forwardRef(function (props, ref) {
        var nextProps = __assign({}, props);
        for (var _i = 0, omitProps_1 = omitProps; _i < omitProps_1.length; _i++) {
            var k = omitProps_1[_i];
            delete nextProps[k];
        }
        return React.createElement(Base, __assign({}, nextProps, { ref: ref }));
    });
}; };
exports.withStyledSystem = function (child) {
    var Base = styled_components_1.default(child)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t", "\n\t\t", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\t\t", "\n\t\t", "\n\t"], ["\n\t\t", "\n\t\t", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\t\t", "\n\t\t", "\n\t"])), styled_system_1.space, styled_system_1.width, styled_system_1.minWidth, styled_system_1.maxWidth, styled_system_1.height, styled_system_1.minHeight, styled_system_1.maxHeight, styled_system_1.display, styled_system_1.fontSize, styled_system_1.color);
    Base.displayName = recompose_1.getDisplayName(child);
    Base.propTypes = propTypes;
    return React.forwardRef(function (props, ref) {
        return React.createElement(Base, __assign({}, props, { ref: ref }));
    });
};
exports.withTooltip = function (Base) {
    return React.forwardRef(function (_a, ref) {
        var props = __rest(_a, []);
        if (!props.tooltip) {
            return React.createElement(Base, __assign({}, props, { ref: ref }));
        }
        var tooltipProps = tooltip.bindProps(props);
        delete props.tooltip;
        return props.disabled ? (React.createElement("span", { style: { display: 'contents' }, onClick: tooltipProps.onClick, onMouseEnter: tooltipProps.onMouseEnter, onMouseLeave: tooltipProps.onMouseLeave },
            React.createElement(Base, __assign({}, props, { ref: ref })))) : (React.createElement(Base, __assign({}, tooltipProps, { ref: ref })));
    });
};
function asRendition(component, additionalEnhancers, passthroughProps) {
    if (additionalEnhancers === void 0) { additionalEnhancers = []; }
    if (passthroughProps === void 0) { passthroughProps = []; }
    return recompose_1.compose.apply(void 0, __spreadArrays([styled_components_1.withTheme], (additionalEnhancers || []), [exports.withTooltip,
        exports.withStyledSystem,
        filterStyledSystemProps(passthroughProps)]))(component);
}
exports.default = asRendition;
var templateObject_1;
